export default function Footer() {
  return (
    <footer className="bg-navy-50 text-navy-800">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-lg bg-brand-500 flex items-center justify-center">
                <i className="ri-shield-cross-line text-xl text-white"></i>
              </div>
              <div>
                <div className="text-base font-display font-bold text-navy-900">
                  Data Health
                </div>
                <div className="text-[10px] tracking-wider uppercase text-brand-600 font-medium">
                  Insurance Consultants
                </div>
              </div>
            </div>
            <p className="text-navy-500 text-sm leading-relaxed mb-4">
              Independent broker specializing in private medical insurance for
              individuals and companies in Houston, TX. Expert advice and market
              comparisons.
            </p>
            <div className="flex gap-2">
              <a
                href="https://www.facebook.com/DataHealthInsuranceConsultants"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-lg bg-navy-100 flex items-center justify-center text-navy-500 hover:bg-brand-500 hover:text-white transition-all duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-base"></i>
              </a>
              <a
                href="https://www.linkedin.com/company/datahealthinsuranceconsultants/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-lg bg-navy-100 flex items-center justify-center text-navy-500 hover:bg-brand-500 hover:text-white transition-all duration-300 cursor-pointer"
              >
                <i className="ri-linkedin-fill text-base"></i>
              </a>
              <a
                href="https://x.com/DataHealthInC"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-lg bg-navy-100 flex items-center justify-center text-navy-500 hover:bg-brand-500 hover:text-white transition-all duration-300 cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-base"></i>
              </a>
              <a
                href="https://www.instagram.com/datahealthinsuranceconsultants/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-lg bg-navy-100 flex items-center justify-center text-navy-500 hover:bg-brand-500 hover:text-white transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-fill text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-display font-bold text-navy-900 mb-4 uppercase tracking-wider">
              <a href="#services">Insurance Services</a>
            </h4>
            <ul className="space-y-3">
              {[
                "Individual Health Plans",
                "Family Coverage",
                "Company Group Plans",
                "Medicare Supplements",
                "Short-Term Insurance",
                "Dental & Vision",
              ].map((link) => (
                <li key={link}>
                  <a
                    href="#services"
                    className="text-navy-500 text-sm hover:text-brand-600 transition-colors cursor-pointer"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-display font-bold text-navy-900 mb-4 uppercase tracking-wider">
              <a href="#about">Quick Links</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: "About Us", href: "#about" },
                { label: "Why Choose Us", href: "#why-us" },
                { label: "Testimonials", href: "#testimonials" },
                { label: "FAQ", href: "#faq" },
                { label: "Get a Quote", href: "#contact" },
                { label: "Contact Us", href: "#contact" },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-navy-500 text-sm hover:text-brand-600 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-display font-bold text-navy-900 mb-4 uppercase tracking-wider">
              <a href="#contact">Contact Info</a>
            </h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-2-fill text-brand-500"></i>
                </div>
                <p className="text-navy-500 text-sm">
                  1500 North Blvd Ste 5000 1006
                  <br />
                  Houston, TX 77006
                </p>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill text-brand-500"></i>
                </div>
                <a
                  href="tel:7138049039"
                  className="text-navy-500 text-sm hover:text-brand-600 transition-colors cursor-pointer"
                >
                  (713) 804-9039
                </a>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-time-fill text-brand-500"></i>
                </div>
                <p className="text-navy-500 text-sm">
                  <strong>Open 24/7</strong>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-navy-200 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-navy-400 text-xs">
              © 2025 Data Health Insurance Consultants. All rights reserved. Houston,
              TX.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="text-navy-400 text-xs hover:text-brand-600 transition-colors cursor-pointer"
              >
                Privacy Policy
              </a>
              <span className="text-navy-300">|</span>
              <a
                href="#"
                className="text-navy-400 text-xs hover:text-brand-600 transition-colors cursor-pointer"
              >
                Terms of Service
              </a>
              <span className="text-navy-300">|</span>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-navy-400 text-xs hover:text-brand-600 transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
